import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("POST_BANK"),
	...createNetworkActions("POST_ORGANISATION_NUMBER"),
};
